import { ApiHelper } from 'shared/helpers/api';
import { getUrl, ROUTES } from 'shared/api/urls';

export const notifyMe = (email: string, productId: string): Promise<any> => {
  const url = getUrl(ROUTES.NOTIFY_ME);
  const headers = {};
  const body = { customerEmail: email, productId };
  return ApiHelper(url, { method: 'POST', headers: headers, body, isBodyJSON: true }).then(
    (data: Response) => {
      if (data.status !== 200) {
        return Promise.reject({ statusCode: data.status });
      }
      return data.json();
    }
  );
};
